export default "/images/archive.svg?791d3b7501e4eab52f00db80bc35b1d5";